module.exports = __webpack_public_path__ + "../resources/images/illustration_search-486bf7d644f94adf0d987c31ceca7a5e.svg";